export default __webpack_public_path__ + "static/media/baic1.ce33558c.png";